// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.textStyling0,
.textStyling1 {
    text-transform: uppercase;
}

.textStyling2 {
    text-transform: capitalize;
}

.textStyling3,
.textStyling4,
.textStyling5 {
    font-style: italic;
    position: relative;
}

[dir=ltr] .textStyling4 {
    padding-left: 15px;
}

[dir=rtl] .textStyling4 {
    padding-right: 15px;
}

.textStyling4:before {
    content: "-";
    position: absolute;
    top: 2px;
    width: 5px;
    line-height: 1em;
}

[dir=ltr] .textStyling4:before {
    left: 2px;
}

[dir=rtl] .textStyling4:before {
    right: 2px;
}

[dir=ltr] .textStyling5 {
    padding-left: 25px;
}

[dir=rtl] .textStyling5 {
    padding-right: 25px;
}

.textStyling5:before {
    content: "--";
    position: absolute;
    top: 2px;
    width: 20px;
    line-height: 1em;
}

[dir=ltr] .textStyling5:before {
    left: 2px;
}

[dir=rtl] .textStyling5:before {
    right: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/css/global/subjectTypography.css"],"names":[],"mappings":";AACA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;IAGI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAFA;IACI,mBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAElB,QAAQ;IACR,UAAU;IACV,gBAAgB;AACpB;;AAPA;IAGI,SAAS;AAIb;;AAPA;IAGI,UAAS;AAIb;;AAEA;IACI,kBAAkB;AACtB;;AAFA;IACI,mBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAElB,QAAQ;IACR,WAAW;IACX,gBAAgB;AACpB;;AAPA;IAGI,SAAS;AAIb;;AAPA;IAGI,UAAS;AAIb","sourcesContent":["\n.textStyling0,\n.textStyling1 {\n    text-transform: uppercase;\n}\n\n.textStyling2 {\n    text-transform: capitalize;\n}\n\n.textStyling3,\n.textStyling4,\n.textStyling5 {\n    font-style: italic;\n    position: relative;\n}\n\n.textStyling4 {\n    padding-left: 15px;\n}\n\n.textStyling4:before {\n    content: \"-\";\n    position: absolute;\n    left: 2px;\n    top: 2px;\n    width: 5px;\n    line-height: 1em;\n}\n\n.textStyling5 {\n    padding-left: 25px;\n}\n\n.textStyling5:before {\n    content: \"--\";\n    position: absolute;\n    left: 2px;\n    top: 2px;\n    width: 20px;\n    line-height: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textStyling0": `textStyling0`,
	"textStyling1": `textStyling1`,
	"textStyling2": `textStyling2`,
	"textStyling3": `textStyling3`,
	"textStyling4": `textStyling4`,
	"textStyling5": `textStyling5`
};
export default ___CSS_LOADER_EXPORT___;
